import { lookup } from '../modules/lookup-result-handler';
import getUserDetails from '../modules/user-details';
import respondToVisibility from '../modules/visibility';

const initialize = () => {
    if (document.getElementById('pageUser').dataset.domainStatus == 1) {
        const emails = document.querySelectorAll('.profile-email');
        emails.forEach((emailElement) => {
            respondToVisibility(emailElement, (visible) => {
                if (visible && emailElement.dataset.processed === 'false') {
                    const username = emailElement.dataset.profileUsername;
                    const userStatus = emailElement.dataset.profileStatus;

                    getUserDetails(username, userStatus, (data) => {
                        if (data) {
                            if (data.forwards && data.forwards.length && emailElement.dataset.profileStatus !== 'closed') {
                                const forwardIconId = `${username}forward`;

                                const forward = document.getElementById(forwardIconId);
                                forward.classList.remove('d-none');
                                forward.setAttribute('title', `${forward.getAttribute('title')} (${data.forwards})`);
                            }

                            let used = 0;
                            let total = 107374182400;
                            if (data.quota) {
                                used = data.quota.used;
                                total = data.quota.total;
                            }

                            // temp convert until prefs moved to bytes
                            let totalGigabytes = total / 1024 / 1024 / 1024;
                            if (total.toString().length < 11) {
                                totalGigabytes = total / 1000 / 1000;
                            }
                            // round to whole number
                            totalGigabytes = Math.round(totalGigabytes);

                            const usedPercentage = Math.round((used / total) * 100);

                            let quotaColorStatus = 'blue';
                            if (usedPercentage >= 50 && usedPercentage < 90) {
                                quotaColorStatus = 'yellow';
                            } else if (usedPercentage >= 90) {
                                quotaColorStatus = 'red';
                            }

                            document.querySelector(`[data-row-username="${username}"] .progress-container`).innerHTML = `
                                <div class="small-text
                                    d-none d-sm-block">
                                    ${usedPercentage}% of ${totalGigabytes}GB
                                </div>
                                <div class="small-text
                                    d-sm-none d-xs-block">
                                    ${usedPercentage}%
                                </div>
                                <div class="progress-bar d-none d-sm-block">
                                    <div class="progress-status progress-status-${quotaColorStatus}" style="width: ${usedPercentage}%${usedPercentage === 0 ? ';border-left:none' : ''}"></div>
                                </div>
                            `;
                        }

                        emailElement.dataset.processed = true;
                    });
                }
            });
        });
    } else {
        lookup('ownership_txt');
    }
};

export default initialize;
